import React, {useContext, useState} from 'react';
import { AuthContext } from "../AuthContext";
import { Navigate } from "react-router-dom";
import { load_fetch, isUserInRole } from "../pr_utils";
import Styles from '../styles/pages/UserManagement.module.css';
import GrantAccessForm from "../components/GrantAccessForm";
import EditUserForm from "../components/EditUserForm";

const UserManagement = ({ page_title }) => {
    const { authStatus } = useContext(AuthContext);
    const [users, setUsers] = useState([]);
    const [showUsers, setShowUsers] = useState(false);
    const [showNonUsers, setShowNonUsers] = useState(false);
    const [nonUsers, setNonUsers] = useState([]);
    const [grantingAccessTo, setGrantingAccessTo] = useState(null); // person_id or person object
    const [editingUser, setEditingUser] = useState(null);
    const [editUserErrorMessage, setEditUserErrorMessage] = useState('');


    // Ajax Functions
    const loadUsers = () => {
        let formData = {
            operation: 'GET_ALL_USERS_WITH_LOGIN'
        };

        load_fetch('Security_Handler.php', formData, (data) => {
            if (!data.ERROR && data.DATA) {
                setUsers(data.DATA);
            } else {
                console.log("Failed to load users:", data);
            }
        });
    };
    const loadNonUsers = () => {
        let formData = {
            operation: 'GET_ALL_USERS_WITHOUT_LOGIN'
        };

        load_fetch('Security_Handler.php', formData, (data) => {
            if (!data.ERROR && data.DATA) {
                setNonUsers(data.DATA);
            } else {
                console.log("Failed to load users:", data);
            }
        });
    };

    // Other Functions
    const handleViewUsersClick = () => {
        setEditingUser(null);
        setGrantingAccessTo(false);
        setShowNonUsers(false);
        setShowUsers(prev => !prev);
        loadUsers();
    };
    const handleViewNonUsersClick = () => {
        setEditingUser(null);
        setGrantingAccessTo(false);
        setShowUsers(false);
        setShowNonUsers(prev => !prev);
        loadNonUsers();
    };
    const handleGrantAccess = (person) => {
        setGrantingAccessTo(person);
        setShowNonUsers(false);
    }
    const closeGrantAccessForm = () => {
        handleViewNonUsersClick();
    }
    const handleEditUser = (user) => {
        console.log(user);
        setEditingUser({...user});
        setShowUsers(false);
    }
    const closeEditingUserForm = () => {
        setEditingUser(null);
    }

    const onUsernameChange = (newUsername) => {
        let formData = editingUser;
        formData.newUsername = newUsername;
        formData.operation = "CHANGE_USERNAME";

        load_fetch("Security_Handler.php", formData, (data) => {
            if(!data.ERROR && data.DATA) {
                setUsers(data.DATA);
                setEditUserErrorMessage('');
            } else {
                console.log(data);
                setEditUserErrorMessage('Warning: Failed to update username. Reload page and try again.');
            }
        });
    }
    const onPasswordReset = (newPassword) => {
        let formData = editingUser;
        formData.newPassword = newPassword;
        formData.operation = "RESET_PASSWORD";

        load_fetch("Security_Handler.php", formData, (data) => {
            if(!data.ERROR && data.DATA) {
                setUsers(data.DATA);
                setEditUserErrorMessage('');
            } else {
                console.log(data);
                setEditUserErrorMessage('Warning: Failed to update password. Reload page and try again.');
            }
        });
    }
    const onRoleChange = (selectedRoles) => {
        let formData = editingUser;
        formData.newRoles = selectedRoles;
        formData.operation = "CHANGE_ROLES";

        load_fetch("Security_Handler.php", formData, (data) => {

            if(!data.ERROR && data.DATA) {
                setUsers(data.DATA);
                setEditUserErrorMessage('');
            } else {
                console.log(data);
                setEditUserErrorMessage('Failed to update roles. Reload page and try again.');
            }
        });
    }



    // Block unauthenticated users or non-admins
    if (!authStatus || !isUserInRole(authStatus, ['ADMIN'])) {
        return <Navigate to="/" />;
    }

    return (
        <div className={Styles.container}>
            <h1 className={Styles.heading}>{page_title || "User Management"}</h1>

            <div className={Styles.buttonBar}>
                <button className={Styles.menuButton} onClick={handleViewNonUsersClick}>
                    Add Login Access for Existing Person
                </button>
                <button className={Styles.menuButton} onClick={handleViewUsersClick}>
                    View All Current Users
                </button>
            </div>

            {showUsers && users.length > 0 && (
                <table className={Styles.userTable}>
                    <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Username</th>
                        <th>Roles</th>
                    </tr>
                    </thead>
                    <tbody>
                    {users.map((user) => (
                        <tr key={user.person_id}>
                            <td className={Styles.grantAccessButtonCell}>
                                <button
                                    onClick={() => handleEditUser(user)}
                                    className={Styles.grant_access_button}
                                >Edit</button>
                            </td>
                            <td>{user.first_name} {user.last_name}</td>
                            <td>{user.username}</td>
                            <td>{user.roles?.join(', ')}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
            {showNonUsers && nonUsers.length > 0 && (
                <table className={Styles.userTable}>
                    <thead>
                    <tr>
                        <th></th>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                    </thead>
                    <tbody>
                    {nonUsers.map((person) => (
                        <tr key={person.person_id}>
                            <td className={Styles.grantAccessButtonCell}>
                                <button
                                    onClick={() => handleGrantAccess(person)}
                                    className={Styles.grant_access_button}
                                >Grant Access</button>
                            </td>
                            <td>{person.first_name} {person.last_name}</td>
                            <td>{person.email}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
            {grantingAccessTo && (
                <GrantAccessForm person={grantingAccessTo} closeForm={closeGrantAccessForm} />
            )}
            {editingUser && (
                <EditUserForm
                    person={editingUser}
                    closeForm={closeEditingUserForm}
                    onUsernameChange={onUsernameChange}
                    onPasswordReset={onPasswordReset}
                    onRoleChange={onRoleChange}
                    errorMessage={editUserErrorMessage}
                />
            )}


        </div>
    );
}

export default UserManagement;
